import * as React from "react";
import * as ReactModal from "react-modal";

import "./modal.scss";

interface IModalProps {
  readonly extraClasses?: string;
  readonly isOpen: boolean;
  readonly openModal?: any;
  readonly closeModal: any;
  readonly children: any;
}

ReactModal.setAppElement("#___gatsby");

class Modal extends React.Component<IModalProps, {}> {
  public render() {
    const extraClasses = this.props.extraClasses || "";

    return (
      <div>
        <ReactModal
          isOpen={this.props.isOpen}
          onRequestClose={this.props.closeModal}
          contentLabel="Demonstration video"
          portalClassName={`ReactModalPortal ${extraClasses}`}
          overlayClassName="ReactModal__Overlay"
          className="ReactModal__Content"
          shouldReturnFocusAfterClose={false}
          shouldCloseOnOverlayClick={true}
          closeTimeoutMS={200}
        >
          <button className="ReactModal__Close" onClick={this.props.closeModal}>
            <span className="icon icon--cross" />
          </button>
          <div className="ReactModal__Guts">{this.props.children}</div>
        </ReactModal>
      </div>
    );
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/modal/modal.tsx